import CustomBlock from '@/components/common/custom-block/custom-block';
import { useTranslate } from 'react-admin';
import { Outlet } from 'react-router';
import Box from '@mui/material/Box';
import AgenciesContainer from '@/components/agencies/agencies-container';

const AgenciesMain = () => {
    const translate = useTranslate();

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: '250px 1fr',
                gap: 1,
                gridTemplateRows: '1fr',
                height: '100%',
                overflowY: 'auto',
            }}
        >
            <CustomBlock label={translate('agency.list.title')}>
                <AgenciesContainer />
            </CustomBlock>

            <Outlet />
        </Box>
    );
};

export default AgenciesMain;
